export default {
    cptDataForm:{
        dataSource: 1, pollTime: 0, dataText: '{"value":90}',
    },
    attribute:{
        title:'线路',titleSize:16,titleColor:'#fff',numSize:30, format:'{value}%',roseType:'false',
        progressWidth:70,
        cptTableData: [{ "name": "指标", "value": "", "namekey": "value" }]
    },
    interaction:{intType: 'none'}
}